import { Tabs } from "@commonlibs";
import clsx from "clsx";
import { MainTabsProps } from "./MainTabs.types";
import MainTabsGroup from "./MainTabsGroup";
import MainTabsPanel from "./MainTabsPanel";

function MainTabs({ className, tabs, ...rest }: MainTabsProps) {
    return (
        <Tabs className={clsx("main-tabs", className)} {...rest}>
            <MainTabsGroup tabs={tabs} />
            <MainTabsPanel tabs={tabs} />
        </Tabs>
    );
}

export default MainTabs;
